<template>
  <div class="access">
    <v-container>
      <v-row class="mt-2" justify="center">

        <v-col cols="2" class="hidden-sm-and-down">
          <v-list class="mt-2 submenu" color="#fafafa" subheader dense>
            <v-subheader>目次</v-subheader>
            <v-list-item @click="smoothScroll('address')">所在地</v-list-item>
            <v-list-item @click="smoothScroll('map')">マップ</v-list-item>
            <v-list-item @click="smoothScroll('route')">研究室へのルート</v-list-item>
              <v-list-item @click="smoothScroll('7f')">・7階</v-list-item>
              <v-list-item @click="smoothScroll('6f')">・6階</v-list-item>
          </v-list>
        </v-col>

        <v-col cols="10">

          <v-row class="mt-2" justify="center">
            <v-col cols="10" xl="8">
              <div id="address" class="heading text-h4 pl-4">所在地</div>
            </v-col>
            <v-col cols="9" xl="7">
              <div>
                <div class="text-h6">〒770-8506</div>
                <div class="text-h6">徳島県徳島市南常三島町2丁目1番地</div>
              </div>
            </v-col>
          </v-row>

          <v-row class="mt-2" justify="center">
            <v-col cols="10" xl="8">
              <div id="map" class="heading text-h4 pl-4 mt-4">マップ</div>
            </v-col>
            <v-col cols="10" xl="7">
              <div style="text-align: center">
                <a
                  href="https://www.google.com/maps?ll=34.077474,134.562103&z=17&t=m&hl=ja&gl=JP&mapclient=embed&q=%E3%80%92770-0814+%E5%BE%B3%E5%B3%B6%E7%9C%8C%E5%BE%B3%E5%B3%B6%E5%B8%82%E5%8D%97%E5%B8%B8%E4%B8%89%E5%B3%B6%E7%94%BA%EF%BC%92%E4%B8%81%E7%9B%AE%EF%BC%91"
                  target="_blank"
                  >> Google Map で開く
                </a>
              </div>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="10" sm="8" md="6" lg="6" xl="4">
              <div>
                <iframe
                  id="content"
                  class="map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3304.689304168256!2d134.55991451559777!3d34.077478023846545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35536d71ab75319d%3A0x90bd686ef5eddd57!2z44CSNzcwLTA4MTQg5b6z5bO255yM5b6z5bO25biC5Y2X5bi45LiJ5bO255S677yS5LiB55uu77yR!5e0!3m2!1sja!2sjp!4v1621758883231!5m2!1sja!2sjp"
                  width="100%"
                  height="auto"
                  allowfullscreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </v-col>
          </v-row>

          <v-row class="mt-2" justify="center">
            <v-col cols="10" xl="8">
              <div id="route" class="heading text-h4 pl-4">研究室へのルート</div>
            </v-col>
            <v-col cols="9" xl="7" justify="center">
                <div class="text-h6">総合研究実験棟に入る</div>
                <v-row class="my-4" justify="center">
                  <v-col cols="12" md="6">
                      <v-img
                        :src="require(`@/assets/map/1.jpg`)"
                        eager
                      ></v-img>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-img
                      :src="require(`@/assets/map/2.jpg`)"
                      eager
                    ></v-img>
                  </v-col>
                </v-row>
            </v-col>

            <v-col cols="9" xl="7" justify="center">
                <div class="text-h6">エレベータに乗る</div>
                <v-row class="my-4" justify="center">
                  <v-col cols="12" md="6">
                      <v-img
                        :src="require(`@/assets/map/3.jpg`)"
                        eager
                      ></v-img>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-img
                      :src="require(`@/assets/map/4.jpg`)"
                      eager
                    ></v-img>
                  </v-col>
                </v-row>
            </v-col>

            <v-col cols="9" xl="7" justify="center">
                <div id="7f" class="text-h6">7階</div>
                <div class="text-h6">エレベータ出て左</div>
                <v-row class="my-4" justify="center">
                  <v-col cols="12" md="6">
                      <v-img
                        :src="require(`@/assets/map/770.jpg`)"
                        eager
                      ></v-img>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-img
                      :src="require(`@/assets/map/771.jpg`)"
                      eager
                    ></v-img>
                  </v-col>
                </v-row>
            </v-col>

            <v-col cols="9" xl="7" justify="center">
                <div class="text-h6">奥に進むと701室（左）と702室（右）があります</div>
                <v-row class="my-4" justify="center">
                  <v-col cols="12" md="6">
                    <v-img
                      :src="require(`@/assets/map/772.jpg`)"
                      eager
                    ></v-img>
                  </v-col>
                </v-row>
            </v-col>

            <v-col cols="9" xl="7" justify="center">
                <div id="6f" class="text-h6">6階</div>
                <div class="text-h6">エレベータ出て左</div>
                <v-row class="my-4" justify="center">
                  <v-col cols="12" md="6">
                      <v-img
                        :src="require(`@/assets/map/660.jpg`)"
                        eager
                      ></v-img>
                  </v-col>
                </v-row>
            </v-col>

            <v-col cols="9" xl="7" justify="center">
                <div class="text-h6">604室（左）と605室（右）があります</div>
                <v-row class="my-4" justify="center">
                  <v-col cols="12" md="6">
                    <v-img
                      :src="require(`@/assets/map/661.jpg`)"
                      eager
                    ></v-img>
                  </v-col>
                </v-row>
            </v-col>
          </v-row>
        </v-col>
        
      </v-row>
      

    </v-container>
  </div>
</template>

<script>
export default {
  name: "Access",

  methods: {
    smoothScroll(target) {
      const element = document.getElementById(target);
      const offset = element.offsetTop; // オフセット位置を取得

      window.scrollTo({
        top: offset,
        behavior: 'smooth' // スムーズスクロールを有効にする
    });
    },
  }
};
</script>

<style scoped>
.heading {
  border-bottom: 2px solid #000;
}
.map {
  border: solid;
  aspect-ratio: 1 / 1;
}
.submenu {
  position:fixed;
}
</style>